import { AppRoutes, CommunitiesRoutes, SpacesRoutes, TabRoutes, WalletRoutes } from './routes'

export const PublicScreensConfig = {
  [AppRoutes.businessConnect]: {
    path: '/b/:business'
  },
  [AppRoutes.home]: {
    path: '',
    initialRouteName: TabRoutes.Wallet,
    screens: {
      [TabRoutes.Wallet]: {
        initialRouteName: '',
        screens: {
          [WalletRoutes.NFTs]: '',
          [WalletRoutes.Coins]: 'coins'
        }
      },
      [TabRoutes.Map]: 'map',
      [TabRoutes.Connect]: {
        screens: {
          [SpacesRoutes.Spaces]: 'spaces',
          [SpacesRoutes.People]: 'people'
        }
      }
    }
  },
  [AppRoutes.CoinDetail_Business]: {
    path: 'b/:business/coins/:coinId'
  },
  [AppRoutes.profileUser]: {
    path: 'me'
  },
  [AppRoutes.editProfile]: {
    path: 'editProfile'
  },
  [AppRoutes.manageAccounts]: {
    path: 'manageAccounts'
  },
  [AppRoutes.updateProfile]: {
    path: 'update-profile'
  },
  [AppRoutes.settingsMetamask]: 'settings/metamask',
  [AppRoutes.Acquire]: '/acquire/:id',
  [AppRoutes.Acquire_Business]: '/b/:businessId/acquire/:id',
  [AppRoutes.LogoutCallback]: {
    path: 'logout-callback'
  },
  [AppRoutes.LoginCallback]: {
    path: '/callback'
  },
  [AppRoutes.Claim]: {
    path: '/claim/:claimId'
  },
  [AppRoutes.NFTDetail]: {
    path: '/token/:tokenId'
  },
  [AppRoutes.NFTDetail_Business]: {
    path: '/b/:business/token/:tokenId'
  },
  [AppRoutes.AcquirePubVariation1]: {
    path: '/acquire-pub-variation/:tokenId'
  },
  [AppRoutes.AcquirePubVariation2]: {
    path: '/AcquirePubVariation/:tokenId'
  },
  [AppRoutes.AcquirePubVariation]: {
    path: '/acquirepubvariation/:tokenId'
  },
  [AppRoutes.MapAR]: {
    path: '/ar'
  },
  [AppRoutes.TokenAR]: {
    path: '/token-ar'
  },
  [AppRoutes.Redirect]: {
    path: '/redirect'
  }
}

const roomParse = {
  roomId: (id: string) => decodeURIComponent(id),
  roomTab: (tab: string) => tab,
  spaceId: (id: string) => decodeURIComponent(id)
}

const communitiesScreens = (withCommunities = true) => {
  const path = withCommunities
    ? 'b/:business/c/:community/space/:spaceId'
    : 'b/:business/space/:spaceId'
  const keyName = withCommunities ? 'Communities' : ''

  return {
    [AppRoutes[`${keyName}Room`]]: {
      path: `${path}`,
      parse: roomParse
    },
    [AppRoutes[`${keyName}RoomMembers`]]: {
      path: `${path}/members`,
      parse: roomParse
    },
    [AppRoutes[`${keyName}RoomThread`]]: {
      path: `${path}/thread`,
      parse: roomParse
    },
    [AppRoutes[`${keyName}RoomNewMessage`]]: {
      path: `${path}/new-message`,
      parse: roomParse
    },
    [AppRoutes[`${keyName}RoomReply`]]: {
      path: `${path}/reply`,
      parse: roomParse
    },
    [AppRoutes[`${keyName}RoomQuestionList`]]: {
      path: `${path}/question-list`,
      parse: roomParse
    },
    [AppRoutes[`${keyName}RoomNewQuestion`]]: {
      path: `${path}/new-question`,
      parse: roomParse
    },
    [AppRoutes[`${keyName}RoomSketchList`]]: {
      path: `${path}/sketch-list`,
      parse: roomParse
    },
    [AppRoutes[`${keyName}RoomNewSketch`]]: {
      path: `${path}/new-sketch`,
      parse: roomParse
    }
  }
}

export const PrivateScreensConfig = {
  [AppRoutes.home]: {
    path: '',
    initialRouteName: TabRoutes.Wallet,
    screens: {
      [TabRoutes.Wallet]: {
        initialRouteName: '',
        screens: {
          [WalletRoutes.NFTs]: '',
          [WalletRoutes.Coins]: 'coins'
        }
      },
      [TabRoutes.Map]: 'map',
      [TabRoutes.Connect]: {
        screens: {
          [SpacesRoutes.Spaces]: 'spaces',
          [SpacesRoutes.People]: 'people'
        }
      }
    }
  },

  [AppRoutes.BusinessProxy]: {
    path: 'b/:business',
    initialRouteName: TabRoutes.Wallet,
    screens: {
      [TabRoutes.Home]: '/',
      [TabRoutes.Wallet]: {
        path: 'wallet'
      },
      [TabRoutes.Map]: 'map',
      [TabRoutes.MapAr]: 'ar',
      [TabRoutes.Connect]: {
        screens: {
          [CommunitiesRoutes.Communities]: 'connect',
          [CommunitiesRoutes.CommunitiesHome]: {
            path: 'c/:community',
            parse: {
              community: (id: string) => decodeURIComponent(id)
            }
          }
        }
      }
    }
  },

  ...communitiesScreens(true),
  ...communitiesScreens(false),

  [AppRoutes.profileOtherUser_Business]: {
    path: 'b/:business/user/:userId',
    parse: {
      userId: (id: string) => decodeURIComponent(id)
    }
  },
  [AppRoutes.CoinDetail_Business]: {
    path: 'b/:business/coins/:coinId'
  },
  [AppRoutes.profileUser]: {
    path: 'me'
  },
  [AppRoutes.editProfile]: {
    path: 'editProfile'
  },
  [AppRoutes.manageAccounts]: {
    path: 'manageAccounts'
  },
  [AppRoutes.updateProfile]: {
    path: 'update-profile'
  },
  [AppRoutes.settingsMetamask]: 'settings/metamask',
  [AppRoutes.Acquire]: '/acquire/:id',
  [AppRoutes.Acquire_Business]: '/b/:businessId/acquire/:id',
  [AppRoutes.LogoutCallback]: {
    path: 'logout-callback'
  },
  [AppRoutes.LoginCallback]: {
    path: '/callback'
  },
  [AppRoutes.Claim]: {
    path: '/claim/:claimId'
  },
  [AppRoutes.NFTDetail]: {
    path: '/token/:tokenId'
  },
  [AppRoutes.NFTDetail_Business]: {
    path: '/b/:business/token/:tokenId'
  },
  [AppRoutes.AcquirePubVariation1]: {
    path: '/acquire-pub-variation/:tokenId'
  },
  [AppRoutes.AcquirePubVariation2]: {
    path: '/AcquirePubVariation/:tokenId'
  },
  [AppRoutes.AcquirePubVariation]: {
    path: '/acquirepubvariation/:tokenId'
  },
  [AppRoutes.MapAR]: {
    path: '/ar'
  },
  [AppRoutes.TokenAR]: {
    path: '/token-ar'
  },
  [AppRoutes.invitePeople]: {
    path: '/people/invite'
  },
  [AppRoutes.profileOtherUser]: {
    path: '/user/:userId',
    parse: {
      userId: (userId: string) => (userId.startsWith('@') ? userId.slice(1, userId.length) : userId)
    }
  },
  [AppRoutes.followList]: {
    path: '/user/:userId/list/:type',
    parse: {
      userId: (userId: string) => (userId.startsWith('@') ? userId.slice(1, userId.length) : userId)
    }
  },
  [AppRoutes.Metaverse]: {
    path: '/space/:spaceId/:type?'
  }
}

export const screenConfigNonWeb = {
  [AppRoutes.Metaverse]: {
    path: '/:spaceHandle'
  }
}
